"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalGroupSizing = exports.ModalGroupSize = void 0;
var ModalGroupSize;
(function (ModalGroupSize) {
    ModalGroupSize["SMALL"] = "small";
    ModalGroupSize["MEDIUM"] = "medium";
    ModalGroupSize["LARGE"] = "large";
    ModalGroupSize["EXTRA_LARGE"] = "extralarge";
    ModalGroupSize["SHEET"] = "sheet";
    ModalGroupSize["FULL_SCREEN"] = "fullscreen";
})(ModalGroupSize = exports.ModalGroupSize || (exports.ModalGroupSize = {}));
var ModalGroupSizing;
(function (ModalGroupSizing) {
    ModalGroupSizing["NORMAL"] = "normal";
    ModalGroupSizing["FULL"] = "full";
})(ModalGroupSizing = exports.ModalGroupSizing || (exports.ModalGroupSizing = {}));
//# sourceMappingURL=ModalGroupProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/ModalGroup/ModalGroupProps.js
// module id = 1681
// module chunks = 8